// extracted by mini-css-extract-plugin
export default {"container":"AboutUsEB_container__2+ev-","header":"AboutUsEB_header__UYW93","ebInfoSection":"AboutUsEB_ebInfoSection__j8Bpc","ebPerson":"AboutUsEB_ebPerson__v4uSG"};